import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=71120176&scoped=true"
import script from "./Settlements.vue?vue&type=script&lang=js"
export * from "./Settlements.vue?vue&type=script&lang=js"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=71120176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71120176",
  null
  
)

export default component.exports